/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-undef */
import { UpdateDynamicBgImage } from './updateDynamicBgImage';

const props = [];

export const UpdateDynamicBgImageDirective = reactDirective => reactDirective(UpdateDynamicBgImage, props);
UpdateDynamicBgImageDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('updateDynamicBgImage', UpdateDynamicBgImageDirective);
